import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "@/components/ui/button";
import { Grip } from "lucide-react";
import { cn } from "@/lib/utils";
import { SectionEditor } from "./SectionEditor";
import { useState } from "react";
import { SectionHeader } from "./components/SectionHeader";
import { isSuperAdmin } from "@/lib/auth";
import { useAuth } from "@/contexts/AuthContext";
import type { Section } from "./types";
interface SortableSectionProps {
  section: Section;
  onUpdate: (section: Section) => void;
  onDelete: () => void;
}
export const SortableSection = ({
  section,
  onUpdate,
  onDelete
}: SortableSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    user
  } = useAuth();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: section.id
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };
  const handleSaveTemplate = () => {
    // Template saving logic would go here
    console.log("Saving template:", section);
  };
  return <div ref={setNodeRef} style={style} className={cn("rounded-lg border bg-card text-card-foreground shadow-sm", isDragging && "opacity-50")}>
      <div className="flex items-center gap-2 border-b bg-slate-200 hover:bg-slate-100">
        <Button variant="ghost" size="icon" className="cursor-grab font-thin text-gray-400">
          <Grip className="h-4 w-4" />
        </Button>
        <div className="flex-1">
          <SectionHeader section={section} isExpanded={isExpanded} onToggle={() => setIsExpanded(!isExpanded)} onDelete={onDelete} onSaveTemplate={handleSaveTemplate} isSuperAdmin={isSuperAdmin(user)} />
        </div>
      </div>

      {isExpanded && <div className="p-4 bg-accent/20 bg-white px-[10px] py-[10px]">
          <SectionEditor section={section} onUpdate={onUpdate} onDelete={onDelete} />
        </div>}
    </div>;
};